import React from "react";
import "aos/dist/aos.css";

const About = () => {
  return (
    <div>
      <div
        className="mt-10 text-center px-3"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="500"
        data-aos-delay="350"
      >
        <h1 className="text-xl font-bold underline text-main">קצת עלינו</h1>

        <p
          className="text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main"
          dir="rtl"
        >
          קייטרינג שובע שמחות עם נסיון של שנים בהכנת אוכל ביתי איכותי, אירועים
          ברמה גבוהה, ובמחירים נוחים.
        </p>

        <p
          className="text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main"
          dir="rtl"
        >
          <span className="font-bold gold-text "> כשר למהדרין </span>
          בשר חלק בית יוסף בהשגחת הרב צבי פרבשטיין - רב הישוב קדומים.
          <br />
          אפשרות לגלאט - מחפוד.
        </p>

        <p
          className="text-lg font-bold max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main"
          dir="rtl"
        >
          צרו איתנו קשר בקליק{" "}
        </p>
      </div>

      <div
        data-aos="fade-zoom-in"
        data-aos-easing="linear"
        className="mt-16 text-3xl font-bold text-center text-main"
      >
        תפריט
      </div>
      <div
        data-aos="fade-zoom-in"
        data-aos-easing="linear"
        className="h-[1px] w-[260px] mx-auto mt-4 bg-line"
      ></div>
    </div>
  );
};

export default About;
